export default __webpack_public_path__ + "data/28d28fb.usa-albers.geo.json";